export enum ReportTypeEnum{
    AgentPortalFBOReports = 1,
    FBOReports = 2,
    FBOAccountPortalWidgets = 3
}

export enum IncentivesReportTypeEnum{
    EagleManagerGlobalCC = 100,
    EagleManagerTotalCC = 720,
    CBGlobalCCLevel0 = 150,
    CBPersonalCCLevel0 = 700,
    CBManagersLevel0 =1,
    CBPersonalCCLevel1 = 600,
    CBManagersLevel1 =3,
    CBPersonalCCLevel2 = 500,
    CBManagersLevel2 =6
   
}


// WEBPACK FOOTER //
// ./src/app/customerservice/enums/report-type.enum.ts